import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Divider,
  Grid2,
  Link,
  Stack,
  TextField,
  InputLabel,
  Typography,
  MenuItem,
  FormControl,
  Select,
  FormHelperText,
  Modal,
  FormLabel,
  Autocomplete,
  
} from "@mui/material";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
    updateOrganization,
  getOrganization,
  getOrganizationContacts
} from "../apis/apiList/organizationApi";
import { getFollowUpTeamMember } from "../apis/apiList/userApi";
import { useMessage } from "../context/MessageContext";
import { useApp } from "../context/AppContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { data } from "jquery";
import axios from "axios";
import BeatLoader from "react-spinners/BeatLoader";
import theme from "../theme/theme";
import DeleteIcon from '@mui/icons-material/Delete';

const subscriberTypeList = [
  // { id: 1, type: "Subscriber", value: "subscriber" },
  // { id: 2, type: "Demo", value: "demo" },
  // { id: 3, type: "Per-project", value: "per-project" },
  // { id: 4, type: "Prospects", value: "prospects" },
  // { id: 5, type: "Leads", value: "leads" },
  // { id: 6, type: "Subscriber - Canceled", value: "subscriber-canceled" },
  { id: 1, type: "Full Automated", value: "automated" },
  { id: 2, type: "Assisted", value: "assisted" },
];

const industries = [
  "Healthcare and Social Assistance",
  "Technology (Information Technology)",
  "Finance and Insurance",
  "Retail Trade",
  "Construction",
  "Manufacturing",
  "Professional and Business Services",
  "Real Estate, Rental, and Leasing",
  "Education Services",
  "Transportation and Warehousing",
  "Energy (Utilities and Renewables)",
  "Telecommunications",
  "Agriculture and Forestry",
  "Hospitality and Tourism",
  "Aerospace and Defense",
  "Entertainment and Media",
  "Food and Beverage Industry",
  "Pharmaceuticals and Biotechnology",
  "Automotive",
  "Others",
];

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const validationSchema = Yup.object().shape({
  organizationName: Yup.string().required("Organization name is required"),
  zip: Yup.string().required("Zip is required"),
  phone: Yup.string()
    // .matches(/^\d+$/, "Phone must be numbers only")
    .required("Phone is required"),
  // purchaseDate: Yup.date().required("Purchase Date is required"),
  // // .max(new Date(), "Purchase Date cannot be in the future"),
  // videoPackage: Yup.number()
  //   .required("Video package is required")
  //   .integer("Must be a whole number")
  //   .positive("Must be a positive number")
  //   .typeError("Must be a number"),
  // subscriberType: Yup.string().required("Subscriber Type is required"),
  // industry: Yup.string().required("Industry is required"),
});
const followUpValidation = Yup.object().shape({
  selectTeamMember: Yup.string().required("Please select team member"),
  startDate: Yup.date().required("Follow Up Date is required"),
});

const style = {
  position: "absolute",
  top: "30%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  //   border: "2px solid #000",
  borderRadius: "10px",
  boxShadow: 24,
  //   p: 4,
};

const CustomButton = ({ value, onClick }) => (
  <Stack direction={"row"} alignItems={"center"}>
    <Button onClick={onClick}>
      <img
        src={"/images/due-date.png"}
        style={{ width: "40px", height: "40px" }}
      />
    </Button>
    <Typography variant="h3">{value}</Typography>
  </Stack>
);

function EditOrganization() {
  const navigate = useNavigate();
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [organizationDetails, setOrganizationDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const { userDetails } = useApp();
  const [followUpTeam, setFollowUpTeam] = useState([]);
  const [organizationContacts, setOrganizationContacts] = useState([]);
  const { showMessage } = useMessage();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmittingFollowUp, setIsSubmittingFollowUp] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [selectedTaskDetails, setSelectedTaskDetails] = useState({});
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { id } = useParams();

  useEffect(() => {
    async function fetchGetOrganization() {
      try {
        console.log("id", id);
        if (id) {
          const organization = await getOrganization({ id });
          console.log("organization", organization);
          if (organization) {
            setOrganizationDetails(organization.data);
            setLoading(false);
          }
        } else {
          showMessage("Organization id not found", "error");
          setLoading(false);
        }
      } catch (error) {
        console.log("error", error);
      }
    }

    fetchGetOrganization();

    async function fetchTeamMember() {
        try {
        const users = await getFollowUpTeamMember();
        console.log("users", users);
        if (users) {
            setFollowUpTeam(users.data);
        }
        } catch (error) {
        console.log("error", error);
        }
    }
    fetchTeamMember();
    
    async function fetchOrganization() {
        try {
            if(id){
                const users = await getOrganizationContacts({id});
                console.log("contacts", users);
                if (users) {
                    setOrganizationContacts(users.data);
                }
            }
        } catch (error) {
        console.log("error", error);
        }
    }
    fetchOrganization();

    
  }, []);

  const handleSubmit = async (values) => {
    console.log("values", values);
    try {
      
    const formData = new FormData();
    //   formData.append("orgLogo", values.orgLogo);
      formData.append("vimeoUri", organizationDetails.vimeoUri);
      formData.append("orgLogoFileId", organizationDetails.orgLogoFileId);
      formData.append(
        "subscriber",
        values.subscriberType === "subscriber" ? "yes" : "no"
      );

      Object.keys(values).forEach((key) => {
        if (values[key] !== null && values[key] !== undefined) {
            if(key !== 'videoOpportunity'){
                formData.append(key, values[key]);
            }
        }
      });

      // Handle taskData
      if (Object.keys(selectedUser).length !== 0) {
        formData.append(
          "teammember",
          `${selectedUser.firstName} ${selectedUser.lastName}`
        );
        formData.append("tduedate", selectedTaskDetails.startDate);
        formData.append("assignedByUserId", userDetails._id);
        formData.append("assignToUserid", selectedTaskDetails.selectTeamMember);
        formData.append("isTaskCreated", true);
      } else {
        formData.append("isTaskCreated", false);
      }
    
      // Handle `videoOpportunity` array
      if (values?.videoOpportunity.length > 0) {
        const vo = JSON.stringify(values.videoOpportunity)
        formData.append(`videoOpportunity`, vo);
      }


      console.log("data create org", data);
      const userData = await updateOrganization(id, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("organization updated ", userData);
      navigate(`/org/${userData.data._id}/projects`);
      showMessage("Organization updated successfully", "success");
      
    } catch (err) {
      console.log("err ", err);
      showMessage(
        err?.response?.data?.message || "Something went wrong",
        "error"
      );
    }
  };

  const handleFollowUpTask = (values) => {
    console.log("values", values);
    console.log("followUpTeam", followUpTeam);
    // const selectedUser = followUpTeam.filter((user)=>user._id == values.selectTeamMember);
    const selectedUser = followUpTeam.find(
      (user) => user._id == values.selectTeamMember
    );
    console.log("selectedUser", selectedUser);
    setSelectedUser(selectedUser);
    setSelectedTaskDetails(values);
    setOpen(false);
  };

  return (
    <div>
      {loading ? (
        <>
          <Box className="loader">
            <BeatLoader
              color={theme.palette.primary.main}
              loading={loading}
              size={25}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </Box>
        </>
      ) : (
        <>
          {Object.keys(organizationDetails).length > 0 && (
            <>
              <Box>
                <Stack
                  sx={{backgroundColor: "#495967"}}
                  py={2}
                  px={4}
                  direction={"row"}
                  justifyContent={"space-between"}
                >
                  <Typography variant="h2" color="#fff">
                    Edit Organization
                  </Typography>
                  <Button
                    variant="contained"
                    backgroundColor={"primary"}
                    onClick={handleOpen}
                  >
                    Create Task
                  </Button>
                </Stack>
                <Box backgroundColor="rgb(28, 47, 65)" p={4}>
                  <Box p={4} backgroundColor="#fff" borderRadius={1}>
                    <Formik
                      initialValues={{
                        organizationName: organizationDetails.organizationName,
                        street: organizationDetails.street,
                        city: organizationDetails.city,
                        state: organizationDetails.state,
                        zip: organizationDetails.zip,
                        phone: organizationDetails.phone,
                        twitter: organizationDetails.twitter,
                        linkedIn: organizationDetails.linkedin,
                        orgLogo: null,
                        subscriberType: organizationDetails.subscriberType,
                        fiscalYear: organizationDetails.fiscalYear,
                        industry: organizationDetails.industry,
                        otherIndustry: organizationDetails.otherIndustry,
                        nickName: organizationDetails.nickName,
                        website: organizationDetails.website,
                        // purchaseDate: organizationDetails.purchaseDate,
                        // videoPackage: organizationDetails.videoPackage,
                        // videoRemaining: organizationDetails.videoRemaining,
                        boxFolderId: organizationDetails.boxFolderId,
                        freshbookProfileId: organizationDetails.freshbookProfileId,
                        notes: organizationDetails.notes,
                        videoOpportunity: organizationDetails.videoOpportunities ? organizationDetails.videoOpportunities: [],
                        name: "",
                        month: "",
                        user: "",
                      }}
                      validationSchema={validationSchema}
                      onSubmit={(values, { setSubmitting }) => {
                        console.log("Form Data:", values);
                        // setIsSubmitting(true);
                        // setSubmitting(false);
                        handleSubmit(values);
                      }}
                    >
                      {({
                        values,
                        setFieldValue,
                        handleChange,
                        handleBlur,
                        isValid,
                        errors,
                        touched,
                      }) => (
                        <Form>
                          <Grid2 container spacing={3}>
                            {/** Organization Name **/}
                            <Grid2 size={{ xs: 12, sm: 12, md: 12 }}>
                              <Field
                                as={TextField}
                                fullWidth
                                label="Organization Name"
                                name="organizationName"
                                variant="outlined"
                                value={values.organizationName}
                                error={
                                  touched.organizationName &&
                                  !!errors.organizationName
                                }
                                helperText={
                                  <ErrorMessage name="organizationName" />
                                }
                              />
                            </Grid2>

                            {/** Street **/}
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                              <Field
                                as={TextField}
                                fullWidth
                                label="Street"
                                name="street"
                                variant="outlined"
                              />
                            </Grid2>

                            {/** City **/}
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                              <Field
                                as={TextField}
                                fullWidth
                                label="City"
                                name="city"
                                variant="outlined"
                              />
                            </Grid2>

                            {/** State **/}
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                              <Field
                                as={TextField}
                                fullWidth
                                label="State"
                                name="state"
                                variant="outlined"
                              />
                            </Grid2>

                            {/** Zip Code **/}
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                              <Field
                                as={TextField}
                                fullWidth
                                label="Zip Code"
                                name="zip"
                                variant="outlined"
                                error={touched.zip && !!errors.zip}
                                helperText={<ErrorMessage name="zip" />}
                              />
                            </Grid2>

                            {/** Phone **/}
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                              <Field
                                as={TextField}
                                fullWidth
                                label="Phone"
                                name="phone"
                                variant="outlined"
                                error={touched.phone && !!errors.phone}
                                helperText={<ErrorMessage name="phone" />}
                              />
                            </Grid2>

                            {/** Twitter **/}
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                              <Field
                                as={TextField}
                                fullWidth
                                label="Twitter"
                                name="twitter"
                                variant="outlined"
                              />
                            </Grid2>

                            {/** LinkedIn **/}
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                              <Field
                                as={TextField}
                                fullWidth
                                label="LinkedIn"
                                name="linkedIn"
                                variant="outlined"
                              />
                            </Grid2>

                            {/** File Upload (Profile Image) **/}
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                              <label htmlFor="logo">Upload logo</label>
                              <input
                                type="file"
                                name="orgLogo"
                                className="form-control"
                                onChange={(event) =>
                                  setFieldValue(
                                    "orgLogo",
                                    event.currentTarget.files[0]
                                  )
                                }
                              />
                            </Grid2>

                            {/* Subscriber Type Dropdown */}
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                              <FormControl
                                fullWidth
                                error={
                                  touched.subscriberType &&
                                  !!errors.subscriberType
                                }
                              >
                                <InputLabel id="subscriberType-label">
                                  Subscriber Type
                                </InputLabel>
                                <Field
                                  as={Select}
                                  labelId="subscriberType-label"
                                  id="subscriberType"
                                  name="subscriberType"
                                  label="Subscriber Type"
                                >
                                  {subscriberTypeList.map((option) => (
                                    <MenuItem
                                      key={option.id}
                                      value={option.value}
                                    >
                                      {option.type}
                                    </MenuItem>
                                  ))}
                                </Field>
                                {/* <FormHelperText>
                                  <ErrorMessage name="subscriberType" />
                                </FormHelperText> */}
                              </FormControl>
                            </Grid2>

                            {/* Fiscal Year Dropdown */}
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                              <FormControl
                                fullWidth
                                error={
                                  touched.fiscalYear && !!errors.fiscalYear
                                }
                              >
                                <InputLabel id="fiscalYear-label">
                                  Fiscal Year
                                </InputLabel>
                                <Field
                                  as={Select}
                                  labelId="fiscalYear-label"
                                  id="fiscalYear"
                                  name="fiscalYear"
                                  label="Fiscal Year"
                                >
                                  {months.map((month, index) => (
                                    <MenuItem key={index} value={month}>
                                      {month}
                                    </MenuItem>
                                  ))}
                                </Field>
                                {/* <FormHelperText>
                                  <ErrorMessage name="fiscalYear" />
                                </FormHelperText> */}
                              </FormControl>
                            </Grid2>

                            {/* Industry Dropdown */}
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                              <FormControl
                                fullWidth
                                error={touched.industry && !!errors.industry}
                              >
                                <InputLabel id="industry-label">
                                  Industry
                                </InputLabel>
                                <Field
                                  as={Select}
                                  labelId="industry-label"
                                  id="industry"
                                  name="industry"
                                  label="Industry"
                                >
                                  {industries.map((industry, index) => (
                                    <MenuItem key={index} value={industry}>
                                      {industry}
                                    </MenuItem>
                                  ))}
                                </Field>
                                {/* <FormHelperText>
                                  <ErrorMessage name="industry" />
                                </FormHelperText> */}
                              </FormControl>
                            </Grid2>

                            {values.industry == "Others" && (
                              <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                                <Field
                                  as={TextField}
                                  fullWidth
                                  label="Other industry"
                                  name="otherIndustry"
                                  variant="outlined"
                                />
                              </Grid2>
                            )}

                            {/** Nickname **/}
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                              <Field
                                as={TextField}
                                fullWidth
                                label="Nickname"
                                name="nickName"
                                variant="outlined"
                                error={touched.nickName && !!errors.nickName}
                                helperText={<ErrorMessage name="nickName" />}
                              />
                            </Grid2>

                            {/** Website **/}
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                              <Field
                                as={TextField}
                                fullWidth
                                label="Website"
                                name="website"
                                variant="outlined"
                                error={touched.website && !!errors.website}
                                helperText={<ErrorMessage name="website" />}
                              />
                            </Grid2>

                            {/** Purchase Date **/}
                            {/* <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                              <Field
                                as={TextField}
                                fullWidth
                                type="date"
                                label="Purchase Date"
                                name="purchaseDate"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                error={Boolean(
                                  touched.purchaseDate && errors.purchaseDate
                                )}
                                helperText={
                                  touched.purchaseDate && errors.purchaseDate
                                    ? errors.purchaseDate
                                    : ""
                                }
                              />
                            </Grid2> */}

                            {/** Video Package **/}
                            {/* <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                              <Field
                                as={TextField}
                                fullWidth
                                type="Number"
                                min={0}
                                label="Video Package"
                                name="videoPackage"
                                variant="outlined"
                                error={
                                  touched.videoPackage && !!errors.videoPackage
                                }
                                helperText={
                                  <ErrorMessage name="videoPackage" />
                                }
                              />
                            </Grid2> */}

                            {/** Video Remaining **/}
                            {/* <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                              <Field
                                as={TextField}
                                fullWidth
                                label="Video Remaining"
                                name="videoRemaining"
                                variant="outlined"
                                error={
                                  touched.videoRemaining &&
                                  !!errors.videoRemaining
                                }
                                helperText={
                                  <ErrorMessage name="videoRemaining" />
                                }
                              />
                            </Grid2> */}

                            {/** Box folder id **/}
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                              <Field
                                as={TextField}
                                fullWidth
                                type="Number"
                                min={0}
                                label="Box folder Id"
                                name="boxFolderId"
                                variant="outlined"
                                error={
                                  touched.boxFolderId && !!errors.boxFolderId
                                }
                                helperText={<ErrorMessage name="boxFolderId" />}
                              />
                            </Grid2>

                            {/** Freshbook Profile Id **/}
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                              <Field
                                as={TextField}
                                fullWidth
                                type="Number"
                                min={0}
                                label="Freshbook Profile Id"
                                name="freshbookProfileId"
                                variant="outlined"
                                error={
                                  touched.freshbookProfileId &&
                                  !!errors.freshbookProfileId
                                }
                                helperText={
                                  <ErrorMessage name="freshbookProfileId" />
                                }
                              />
                            </Grid2>

                            {/** Notes **/}
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                              <Field
                                as={TextField}
                                fullWidth
                                label="Notes"
                                name="notes"
                                variant="outlined"
                                error={touched.notes && !!errors.notes}
                                helperText={<ErrorMessage name="notes" />}
                              />
                            </Grid2>
                          </Grid2>

                          <Grid2 size={{ xs: 12, sm: 12, md: 12 }} mt={4}>
                            <label>Video Opportunities</label>
                            <FieldArray name="videoOpportunity">
                              {({ push, remove }) => (
                                <>
                                  <Grid2 container spacing={2}>
                                    {/* Video Opportunity Name */}
                                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                                      <Field
                                        as={TextField}
                                        name="name"
                                        label="Video Opportunity Name"
                                        variant="outlined"
                                        margin="normal"
                                        fullWidth
                                      />
                                    </Grid2>

                                    {/* Month Select */}
                                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                                      <FormControl margin="normal" fullWidth>
                                        <InputLabel>Month</InputLabel>
                                        <Field as={Select} name="month">
                                          {months.map((month) => (
                                            <MenuItem key={month} value={month}>
                                              {month}
                                            </MenuItem>
                                          ))}
                                        </Field>
                                      </FormControl>
                                    </Grid2>

                                    {/* Team User Select */}
                                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                                      <FormControl margin="normal" fullWidth>
                                        <InputLabel>Organization contacts</InputLabel>
                                        <Field as={Select} name="user">
                                          {organizationContacts.map((user) => (
                                            <MenuItem
                                              key={user._id}
                                              value={user._id}
                                            >
                                              {`${user.firstName} ${user.lastName}`}
                                            </MenuItem>
                                          ))}
                                        </Field>
                                      </FormControl>
                                    </Grid2>

                                    {/* Add Button */}
                                    <Grid2
                                      size={{ xs: 12, sm: 6, md: 2 }}
                                      alignContent={"center"}
                                    >
                                      <Button
                                        variant="contained"
                                        sx={{backgroundColor: '#495967', textTransform: 'capitalize'}}
                                        fullWidth
                                        onClick={() => {
                                          if (
                                            values.name &&
                                            values.month &&
                                            values.user
                                          ) {
                                            push({
                                              name: values.name,
                                              month: values.month,
                                              user: values.user,
                                            });
                                            setFieldValue("name", "");
                                            setFieldValue("month", "");
                                            setFieldValue("user", "");
                                          }
                                        }}
                                      >
                                        Add Opportunity
                                      </Button>
                                    </Grid2>
                                  </Grid2>

                                  {/* Display Added Items */}
                                  {values.videoOpportunity.length > 0 && (
                                    <Box mb={8}>
                                      {values.videoOpportunity.map(
                                        (item, index) => (
                                          <>
                                            <Stack direction={"row"} justifyContent={'space-between'} mt={1} mb={1}>
                                                <Box sx={{display: 'flex', width: '100%', gap: '15px'}}>
                                                    <Typography sx={{width: '35%'}}>
                                                        {item.name}
                                                    </Typography >
                                                    <Typography sx={{width: '30%'}}>
                                                        {item.month}
                                                    </Typography>
                                                    <Typography sx={{width: '30%'}}>
                                                        {/* {item.user} */}
                                                        {organizationContacts.map((user)=>(
                                                            user._id == item.user ? `${user.firstName} ${user.lastName}`: ''
                                                        ))}
                                                    </Typography>
                                                </Box>
                                              {/* <Button
                                                variant="contained"
                                                sx={{backgroundColor: '#fff', width: '10%'}}
                                                size="small"
                                                onClick={() => remove(index)}
                                                style={{ marginLeft: "10px" }}
                                              >
                                                Remove
                                              </Button> */}
                                              <Box mr={2}>
                                                <DeleteIcon color="primary" sx={{cursor:'pointer'}} onClick={() => remove(index)}/>
                                              </Box>
                                            </Stack>
                                            {/* <li key={index}>
                                              <strong>{item.name}</strong> -{" "}
                                              {item.month} - {item.user}
                                              <Button
                                                variant="contained"
                                                color="secondary"
                                                size="small"
                                                onClick={() => remove(index)}
                                                style={{ marginLeft: "10px" }}
                                              >
                                                Remove
                                              </Button>
                                            </li> */}
                                            <Divider />
                                          </>
                                        )
                                      )}
                                    </Box>
                                  )}
                                </>
                              )}
                            </FieldArray>
                          </Grid2>

                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              gap: 1,
                              justifyContent: "start",
                              mt: 4,
                            }}
                          >
                            <Button
                              variant="contained"
                              type="submit"
                              disabled={!isValid || isSubmitting}
                            >
                              {isSubmitting ? "Updating..." : "Update"}
                            </Button>
                            <Button
                              variant="contained"
                              onClick={() => {
                                navigate(`/org/${organizationDetails._id}/projects`);
                              }}
                            >
                              Cancel
                            </Button>
                            {/* <Button variant='contained' onClick={() => { handleCancel() }}>Cancel</Button> */}
                          </Box>
                        </Form>
                      )}
                    </Formik>
                  </Box>
                </Box>
              </Box>
            </>
          )}
        </>
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box sx={{ padding: "20px 20px" }}>
            <Typography variant="h2">Create Follow-Up Task</Typography>
          </Box>
          <Divider />
          <Box sx={{ padding: "10px 20px" }}>
            <Box>
              <Formik
                initialValues={{
                  selectTeamMember: selectedTaskDetails.selectTeamMember
                    ? selectedTaskDetails.selectTeamMember
                    : "",
                  startDate: selectedTaskDetails.startDate
                    ? selectedTaskDetails.startDate
                    : "",
                }}
                validationSchema={followUpValidation}
                onSubmit={(values, { setSubmitting }) => {
                  console.log("Form Data:", values);
                  // setIsSubmitting(true);
                  // setSubmitting(false);
                  handleFollowUpTask(values);
                }}
              >
                {({
                  values,
                  setFieldValue,
                  handleChange,
                  handleBlur,
                  isValid,
                  errors,
                  touched,
                }) => (
                  <Form>
                    <Typography id="select-team-label">Select Team</Typography>
                    <FormControl
                      sx={{ marginBottom: "30px", marginTop: "10px" }}
                      fullWidth
                      error={
                        touched.selectTeamMember && !!errors.selectTeamMember
                      }
                    >
                      <Field
                        as={Select}
                        id="selectTeamMember"
                        value={values.selectTeamMember}
                        name="selectTeamMember"
                      >
                        {followUpTeam.map((option) => (
                          <MenuItem key={option._id} value={option._id}>
                            {`${option.firstName} ${option.lastName}`}
                          </MenuItem>
                        ))}
                      </Field>
                      <FormHelperText>
                        <ErrorMessage name="selectTeamMember" />
                      </FormHelperText>
                    </FormControl>
                    <Stack direction={"row"} alignItems={"center"} gap={2}>
                      <Typography>Follow Up Date:</Typography>
                      <DatePicker
                        selected={values.startDate}
                        minDate={moment().toDate()}
                        dateFormat="d MMMM yyyy"
                        onChange={(date) => setFieldValue("startDate", date)}
                        customInput={<CustomButton />}
                        value={values.startDate}
                      />
                      <FormHelperText>
                        <ErrorMessage name="startDate" />
                      </FormHelperText>
                    </Stack>
                    <Stack
                      direction={"row"}
                      justifyContent={"end"}
                      gap={2}
                      mr={2}
                      mb={3}
                    >
                      <Button
                        type="submit"
                        variant="contained"
                        disabled={!isValid || isSubmittingFollowUp}
                      >
                        {isSubmittingFollowUp ? "Saving..." : "Save"}
                      </Button>
                      <Button variant="contained" onClick={handleClose}>
                        Cancel
                      </Button>
                    </Stack>
                  </Form>
                )}
              </Formik>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

export default EditOrganization;
